import "@mdi/font/css/materialdesignicons.css"
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import icons from "./IconesPersonalizados";

const optionsVuetify = {
  iconfont: "mdi",
  lang: {
    locales: {
      pt: {
        dataIterator: {
          rowsPerPageText: "Itens por página:",
          rowsPerPageAll: "Todos",
          pageText: "{0}-{1} de {2}",
          noResultsText: "Nenhum dado encontrado",
          nextPage: "Próxima página",
          prevPage: "Página anterior"
        },
        dataTable: {
          rowsPerPageText: "Linhas por página:"
        },
        noDataText: "Não há dados disponíveis",
        carousel: {
          prev: "Visual anterior",
          next: "Próximo visual"
        }
      }
    },
    current: "pt"
  },
  theme: {
    pmz: "#0E314A",
    primary: "#0E314A"
  }
};

Vue.use(Vuetify, optionsVuetify);

export default new Vuetify({
  iconfont: "mdi",
  lang: {
    locales: {
      pt: {
        dataIterator: {
          pageText: "{0}-{1} de {2}",
          noResultsText: "Nenhum dado encontrado",
          loadingText: 'Carregando itens...',
        },
        dataTable: {
          itemsPerPageText: "Linhas por página:"
        },
        noDataText: "Não há dados disponíveis",
        close: 'Fechar',
        dataFooter: {
          itemsPerPageText: 'Itens por página:',
          itemsPerPageAll: 'Todos',
          nextPage: 'Próxima página',
          prevPage: 'Página anterior',
          firstPage: 'Primeira página',
          lastPage: 'Última página',
        },
        datePicker: {
          itemsSelected: '{0} selecionados',
        },
        carousel: {
          prev: 'Anterior',
          next: 'Próxiimo',
        },
        calendar: {
          moreEvents: '{0} mais',
        },
      }
    },
    current: "pt",
  },
  icons
});
